'use client';

import { c as _c } from "react/compiler-runtime";
import * as ToggleGroupPrimitive from '@radix-ui/react-toggle-group';
import { cn } from '@repo/ui/lib';
import * as React from 'react';
import { toggleVariants } from './toggle';
const ToggleGroupContext = React.createContext({
  size: 'default',
  variant: 'default'
});
function ToggleGroup(t0) {
  const $ = _c(20);
  let children;
  let className;
  let props;
  let size;
  let variant;
  if ($[0] !== t0) {
    ({
      children,
      className,
      size,
      variant,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
    $[4] = size;
    $[5] = variant;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
    size = $[4];
    variant = $[5];
  }
  let t1;
  if ($[6] !== className) {
    t1 = cn("group/toggle-group flex w-fit items-center rounded-md data-[variant=outline]:shadow-xs", className);
    $[6] = className;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] !== size || $[9] !== variant) {
    t2 = {
      size,
      variant
    };
    $[8] = size;
    $[9] = variant;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  let t3;
  if ($[11] !== children || $[12] !== t2) {
    t3 = <ToggleGroupContext.Provider value={t2}>{children}</ToggleGroupContext.Provider>;
    $[11] = children;
    $[12] = t2;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  let t4;
  if ($[14] !== props || $[15] !== size || $[16] !== t1 || $[17] !== t3 || $[18] !== variant) {
    t4 = <ToggleGroupPrimitive.Root className={t1} data-size={size} data-slot="toggle-group" data-variant={variant} {...props}>{t3}</ToggleGroupPrimitive.Root>;
    $[14] = props;
    $[15] = size;
    $[16] = t1;
    $[17] = t3;
    $[18] = variant;
    $[19] = t4;
  } else {
    t4 = $[19];
  }
  return t4;
}
function ToggleGroupItem(t0) {
  const $ = _c(16);
  let children;
  let className;
  let props;
  let size;
  let variant;
  if ($[0] !== t0) {
    ({
      children,
      className,
      size,
      variant,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
    $[4] = size;
    $[5] = variant;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
    size = $[4];
    variant = $[5];
  }
  const context = React.useContext(ToggleGroupContext);
  const t1 = context.size || size;
  const t2 = context.variant || variant;
  let t3;
  if ($[6] !== className || $[7] !== t1 || $[8] !== t2) {
    t3 = cn(toggleVariants({
      size: t1,
      variant: t2
    }), "min-w-0 flex-1 shrink-0 rounded-none shadow-none first:rounded-l-md last:rounded-r-md focus:z-10 focus-visible:z-10 data-[variant=outline]:border-l-0 data-[variant=outline]:first:border-l", className);
    $[6] = className;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const t4 = context.size || size;
  const t5 = context.variant || variant;
  let t6;
  if ($[10] !== children || $[11] !== props || $[12] !== t3 || $[13] !== t4 || $[14] !== t5) {
    t6 = <ToggleGroupPrimitive.Item className={t3} data-size={t4} data-slot="toggle-group-item" data-variant={t5} {...props}>{children}</ToggleGroupPrimitive.Item>;
    $[10] = children;
    $[11] = props;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
}
export { ToggleGroup, ToggleGroupItem };